import { render, staticRenderFns } from "./EditSeriesEventTemplatePanel.vue?vue&type=template&id=7d60c59f&scoped=true"
import script from "./EditSeriesEventTemplatePanel.vue?vue&type=script&lang=js"
export * from "./EditSeriesEventTemplatePanel.vue?vue&type=script&lang=js"
import style0 from "./EditSeriesEventTemplatePanel.vue?vue&type=style&index=0&id=7d60c59f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d60c59f",
  null
  
)

export default component.exports